import { createSelector } from '@reduxjs/toolkit';

import { searchResponseSelectionSelector } from 'Core/selectors/search';
import type { ReduxStateType } from 'Core/store';
import { FacetValue, WeightedColor } from 'Models/index';

export function createSelectedColorSelector(
  color: string,
): (state: ReduxStateType) => WeightedColor | undefined {
  return createSelector(searchResponseSelectionSelector, (selection) => {
    const selectedValue = selection.find(
      (sel) => FacetValue.isColor(sel) && new WeightedColor(sel.term).color === color,
    );
    return selectedValue ? new WeightedColor(selectedValue.term) : undefined;
  });
}
